const home = {
  // Hero
  hero_headline_1: 'Le Leadership dont votre',
  hero_headline_family: 'Famille',
  hero_headline_and: 'et votre',
  hero_headline_school: 'École',
  hero_headline_2: 'ont besoin',
  hero_description: 'Transformez vos relations familiales et votre gestion éducative avec des méthodologies éprouvées par <strong>17 ans d\'expérience</strong>. Découvrez le chemin vers un leadership qui génère des résultats réels et durables.',
  hero_btn_books: 'Livres',
  hero_btn_courses: 'Cours',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Ans d\'Expérience',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Livres et Œuvres:',
  books_title_highlight: 'Le Début de la Transformation',
  books_subtitle: 'Livres et e-books qui ont déjà transformé des milliers de familles et de professionnels de l\'éducation au Brésil',
  books_format: 'E-book PDF',
  books_btn_buy: 'Acheter',
  books_btn_details: 'Voir les Détails',
  books_guarantee: 'Garantie 7 jours',
  books_coming_soon: 'Bientôt disponible',
  books_coming_new: 'Nouveau titre bientôt',
  books_coming_desc: 'Nous préparons encore plus de contenu incroyable pour vous !',
  books_notify_label: 'Me prévenir au lancement',
  books_details_hover: 'Voir les Détails',

  // Courses section
  courses_title: 'Formation d\'Élite:',
  courses_title_highlight: 'La Méthode Complète',
  courses_subtitle: 'Cours en ligne structurés avec des méthodologies validées par plus de 17 ans d\'expérience pratique',
  courses_badge: 'Cours en ligne',
  courses_modules: 'modules',
  courses_btn_enroll: 'S\'inscrire Maintenant',
  courses_btn_details: 'Voir les Détails',
  courses_guarantee: 'Garantie 30 jours',
  courses_coming_new: 'Nouveau cours bientôt',
  courses_coming_desc: 'Nous préparons une nouvelle formation incroyable pour vous !',
  courses_students: 'étudiants',
  courses_or: 'ou',
  courses_hover_view: 'Voir le Cours',
  courses_testimonials_title: 'Ce Que Disent Nos Étudiants',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Votre Prochaine Étape:',
  action_title_highlight: 'Centre d\'Action',
  action_subtitle: 'Choisissez la voie idéale pour votre transformation',
  action_quick_title: 'Démarrage Rapide',
  action_quick_desc: 'Commencez dès aujourd\'hui avec nos e-books et transformez votre gestion',
  action_quick_btn: 'Voir les Livres',
  action_deep_title: 'Formation Complète',
  action_deep_desc: 'Maîtrisez toutes les stratégies avec nos cours structurés',
  action_deep_btn: 'Voir les Cours',
  action_deep_badge: 'LE PLUS POPULAIRE',
  action_elite_title: 'Accès Élite',
  action_elite_desc: 'Mentorat exclusif pour des résultats extraordinaires',
  action_faq_title: 'Questions Fréquentes',
  action_faq_q1: 'Comment fonctionne l\'accès aux cours ?',
  action_faq_a1: 'Après l\'achat, vous recevez un accès immédiat et à vie au contenu complet pour étudier à votre rythme.',
  action_faq_q2: 'Les e-books sont-ils physiques ou numériques ?',
  action_faq_a2: 'Tous nos livres sont en format PDF numérique, permettant un accès instantané après l\'achat.',
  action_faq_q3: 'Quelle est la différence entre les cours et le mentorat ?',
  action_faq_a3: 'Les cours sont du contenu structuré pour un apprentissage autonome. Le mentorat est un accompagnement personnalisé et exclusif.',
  action_faq_q4: 'Y a-t-il une garantie de satisfaction ?',
  action_faq_a4: 'Oui ! Nous offrons 7 jours de garantie pour les e-books et 30 jours pour les cours. Si vous n\'êtes pas satisfait, nous remboursons votre investissement.',
  action_faq_q5: 'Comment fonctionne le processus de candidature au mentorat ?',
  action_faq_a5: 'Après avoir rempli le formulaire, notre équipe analyse votre profil et vous contacte sous 24 heures pour programmer une conversation.',
  action_cta_title: 'Prêt à Transformer votre Leadership ?',
  action_cta_desc: 'Rejoignez les professionnels qui ont déjà transformé leur vie avec nos méthodes',
  action_cta_btn_explore: 'Explorer les Produits',

  // Social Proof
  social_title: 'Contenu Exclusif sur Instagram',
  social_subtitle: 'Suivez des contenus sur la gestion éducative et les relations familiales',
  social_follow: 'Suivre Maintenant',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Transformer les leaders éducatifs et les familles grâce à des méthodologies éprouvées depuis plus de 17 ans.',
  footer_products_title: 'Produits',
  footer_products_books: 'Livres et E-books',
  footer_products_courses: 'Cours en Ligne',
  footer_products_talks: 'Conférences In-Company',
  footer_products_webinars: 'Webinaires en Direct',
  footer_company_title: 'Entreprise',
  footer_company_about: 'À Propos',
  footer_company_contact: 'Contact',
  footer_support_title: 'Support',
  footer_support_help: 'Centre d\'Aide',
  footer_support_privacy: 'Politique de confidentialité',
  footer_support_terms: 'Conditions d\'utilisation',
  footer_support_refund: 'Parler de remboursement',
  footer_copyright: '© {{ano}} SB Family & Mastery. Tous droits réservés.',
  footer_secure: 'Site Sécurisé',
  footer_payment: 'Paiement Protégé',

  // FAQ Page
  faq_badge: 'Centre d\'Aide',
  faq_title: 'Comment pouvons-nous vous aider ?',
  faq_subtitle: 'Trouvez des réponses aux questions les plus courantes sur la plateforme, les cours, les paiements et les certificats.',
  faq_cat_geral: 'Général',
  faq_cat_acesso: 'Accès et Compte',
  faq_cat_cursos: 'Cours',
  faq_cat_pagamento: 'Paiement',
  faq_cat_certificado: 'Certificats',
  faq_cat_mentoria: 'Mentorat',
  faq_not_found_title: 'Vous n\'avez pas trouvé ce dont vous aviez besoin ?',
  faq_not_found_desc: 'Notre équipe de support est disponible du lundi au vendredi, de 8h à 18h.',
  faq_not_found_btn: 'Parler au Support',

  // Cursos Page
  cursos_badge: 'Programmes d\'Élite',
  cursos_title: 'Catalogue de',
  cursos_title_highlight: 'Cours',
  cursos_subtitle: 'Des méthodologies éprouvées pour transformer votre gestion éducative et vos relations familiales.',
  cursos_stat_courses: 'cours disponibles',
  cursos_stat_rating: 'Note moyenne 4.8',
  cursos_stat_guarantee: 'Garantie 30 jours',
  cursos_search_placeholder: 'Rechercher des cours...',
  cursos_filter_all_areas: 'Tous les Domaines',
  cursos_filter_all_levels: 'Tous les Niveaux',
  cursos_filter_all_durations: 'Toute Durée',
  cursos_filter_clear: 'Effacer',
  cursos_results_found_one: 'cours trouvé',
  cursos_results_found_many: 'cours trouvés',
  cursos_results_none: 'Aucun cours trouvé',
  cursos_no_results_title: 'Aucun résultat trouvé',
  cursos_no_results_desc: 'Essayez d\'ajuster les filtres ou de chercher avec d\'autres mots-clés.',
  cursos_no_results_btn: 'Effacer les Filtres',
  cursos_badge_online: 'Cours en Ligne',
  cursos_modules_label: 'modules',
  cursos_enroll_btn: 'S\'inscrire Maintenant',
  cursos_details_btn: 'Voir les Détails',
  cursos_view_btn: 'Voir le Cours',
  cursos_cta_title: 'Vous Voulez des Résultats Plus Rapides ?',
  cursos_cta_desc: 'Le Mentorat Premium est le moyen le plus direct de transformer votre école ou votre famille avec un accompagnement personnalisé.',
  cursos_students_label: 'étudiants',
  cursos_or_label: 'ou',

  // Sobre Page
  sobre_badge: 'À Propos',
  sobre_title: '17 ans à former des leaders qui transforment',
  sobre_subtitle: 'SB Family & Mastery est né de la conviction que le véritable leadership commence à la maison et s\'étend aux institutions. Nous sommes une plateforme d\'éducation exécutive avec une mission claire : transformer les familles et les écoles par des connaissances applicables.',
  sobre_mission_label: 'Notre Mission',
  sobre_vision_label: 'Notre Vision',
  sobre_purpose_label: 'Notre But',
  sobre_mission_text: 'Outiller les leaders éducatifs et familiaux avec des outils pratiques et des méthodologies éprouvées qui génèrent une transformation réelle et mesurable dans la vie des personnes et des institutions.',
  sobre_vision_text: 'Être la principale référence en éducation exécutive pour la gestion familiale et scolaire au Brésil, formant une génération de leaders qui construisent des héritages durables.',
  sobre_purpose_text: 'Nous croyons que chaque famille renforcée et chaque école bien gérée produit des vagues d\'impact positif qui traversent les générations. C\'est pourquoi nous faisons ce que nous faisons.',
  sobre_values_title: 'Nos Valeurs',
  sobre_values_desc: 'Les piliers qui guident chaque décision, chaque contenu et chaque interaction de notre équipe.',
  sobre_team_badge: 'Qui se cache derrière',
  sobre_team_title: 'Notre Équipe Fondatrice',
  sobre_team_desc: 'Professionnels avec une solide expérience combinée en éducation, psychologie et technologie.',
  sobre_timeline_title: 'Notre Parcours',
  sobre_timeline_desc: '17 ans d\'histoire, d\'apprentissage et d\'impact.',
  sobre_cta_title: 'Faites partie de la transformation',
  sobre_cta_desc: 'Rejoignez les familles et éducateurs qui ont déjà choisi de grandir avec SB Family & Mastery.',
  sobre_cta_contact: 'Contactez-nous',

  // Contato Page
  contato_badge: 'Contactez-nous',
  contato_title: 'Nous sommes là pour vous aider',
  contato_subtitle: 'Notre équipe de support répond dans les 24 heures ouvrables. Choisissez le canal le plus pratique pour vous.',
  contato_form_title: 'Envoyer un message',
  contato_form_desc: 'Remplissez le formulaire et nous vous répondrons dans les 24 heures ouvrables.',
  contato_name_label: 'Nom complet *',
  contato_email_label: 'E-mail *',
  contato_subject_label: 'Sujet',
  contato_message_label: 'Message *',
  contato_send_btn: 'Envoyer le Message',
  contato_sending: 'Envoi en cours...',
  contato_success_title: 'Message envoyé !',
  contato_success_desc: 'Notre équipe vous répondra dans les 24 heures ouvrables.',
  contato_success_new: 'Envoyer un nouveau message',
  contato_error: 'Erreur lors de l\'envoi. Réessayez ou utilisez un autre canal.',
  contato_faq_title: 'Questions Rapides',
  contato_faq_desc: 'Votre question est peut-être déjà répondue dans notre FAQ :',
  contato_faq_all: 'Voir tout le Centre d\'Aide',
  contato_hours_title: 'Horaires d\'Assistance',
  contato_online: 'Support en ligne maintenant',
  contato_hours_weekday: 'Lundi – Vendredi',
  contato_hours_weekday_val: '8h à 18h',
  contato_hours_saturday: 'Samedi',
  contato_hours_saturday_val: '9h à 13h',
  contato_hours_sunday: 'Dimanche et Jours fériés',
  contato_hours_sunday_val: 'Fermé',
};

export default home;
